var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.47775 0.652547C2.20555 0.305893 1.83636 0.111146 1.45141 0.111146C1.06646 0.111146 0.697273 0.305893 0.425072 0.652547C0.15287 0.999201 -5.34058e-05 1.46937 -5.34058e-05 1.95961C-5.34058e-05 2.44985 0.15287 2.92001 0.425072 3.26667L10.0847 15.5684C10.2193 15.7404 10.3793 15.8769 10.5554 15.9701C10.7315 16.0632 10.9204 16.1111 11.1111 16.1111C11.3018 16.1111 11.4906 16.0632 11.6667 15.9701C11.8428 15.8769 12.0028 15.7404 12.1374 15.5684L21.797 3.26667C22.0692 2.92001 22.2222 2.44985 22.2222 1.95961C22.2222 1.46937 22.0692 0.999201 21.797 0.652547C21.5248 0.305893 21.1557 0.111146 20.7707 0.111146C20.3858 0.111146 20.0166 0.305893 19.7444 0.652547L11.1123 11.6457L2.47775 0.652547Z",
    fill: "#0B5226"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/caret-down.64455926876854f6b2e0d2195c68a2a0.svg";
export { ForwardRef as ReactComponent };